import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { createCustomElement } from '@angular/elements';
import { FormsModule } from '@angular/forms';
import { GuizGameComponent } from './quiz-game/quiz-game.component';
import { HttpClientModule } from '@angular/common/http';
import { IdentifyGameComponent } from './identify-game/identify-game.component';
import { IdentifyServiceService } from './identify-game/identify-service.service';
import { Injector, NgModule } from '@angular/core';
import { LabelService } from './label.service';
import { LightboxModule } from 'ngx-lightbox';
import { MatchingGameComponent } from './matching-game/matching-game.component';
import { MatchingGameService } from './matching-game/matching-game.service';
import { MultiSelectModule } from 'primeng/multiselect';
import { NgxCsvParserModule } from 'ngx-csv-parser';
import { QuizGameService } from './quiz-game/quiz-game.service';
import { RouterModule, Routes } from '@angular/router';
import { SeedBankComponent } from './seed-bank/seed-bank.component';
import { SeedDataService } from './seed-bank/seed-data.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'seed-bank',
    pathMatch: 'full',
  },
  {
    path: 'seed-bank',
    component: SeedBankComponent,
  },
];

@NgModule({
  declarations: [AppComponent, SeedBankComponent, GuizGameComponent, MatchingGameComponent, IdentifyGameComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(routes, { useHash: true }),
    HttpClientModule,
    FormsModule,
    NgxCsvParserModule,
    LightboxModule,
    MultiSelectModule,
  ],
  providers: [LabelService, SeedDataService, QuizGameService, MatchingGameService, IdentifyServiceService],
  entryComponents: [SeedBankComponent, GuizGameComponent, MatchingGameComponent, IdentifyGameComponent],
})
export class AppModule {
  constructor(private injector: Injector) {}

  ngDoBootstrap() {
    const seedBankElement = createCustomElement(SeedBankComponent, { injector: this.injector });
    customElements.define('seed-bank-element', seedBankElement);

    const guizGameElement = createCustomElement(GuizGameComponent, { injector: this.injector });
    customElements.define('quiz-game-element', guizGameElement);

    const matchingGameElement = createCustomElement(MatchingGameComponent, { injector: this.injector });
    customElements.define('matching-game-element', matchingGameElement);

    const identifyGameElement = createCustomElement(IdentifyGameComponent, { injector: this.injector });
    customElements.define('identify-game-element', identifyGameElement);
  }
}
